import { render } from "./footer-comp.vue?vue&type=template&id=391c83e2&scoped=true"
import script from "./footer-comp.vue?vue&type=script&lang=js"
export * from "./footer-comp.vue?vue&type=script&lang=js"

import "./footer-comp.vue?vue&type=style&index=0&id=391c83e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391c83e2"]])

export default __exports__